import { Text, VStack, Wrap } from '@wegroup/design-system';
import React from 'react';

interface Props {
  title: string;
  wrapItems?: boolean;
}

const ComparisonMatrixOverviewBox: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  children,
  wrapItems,
}) => {
  return (
    <VStack
      align="flex-start"
      spacing="4"
      borderTop="1px solid"
      borderColor="gray.200"
      py="4"
    >
      <Text>{title}</Text>
      <Wrap display={wrapItems ? 'flex' : 'block'} spacing="2">
        {children}
      </Wrap>
    </VStack>
  );
};

export default ComparisonMatrixOverviewBox;
